import React from 'react';
import ReactDOM from 'react-dom';
import './assets/css/App.css';
import './assets/css/theme.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AuthLayout from './layouts/auth';
import HomeLayout from './layouts/home';
import { ChakraProvider } from '@chakra-ui/react';
import theme from './theme/theme';
import { AuthProvider } from './contexts/auth'; 
import 'primereact/resources/primereact.css';
import 'primeflex/primeflex.css';
// Add the TrustedTypePolicy before the app renders
if (window.trustedTypes) {
  try {
    // Check if the policy already exists, using TypeScript-safe methods
    const existingPolicy = window.trustedTypes.createPolicy('default', {
      createHTML: (input) => input, // Ensure this is safe.
    });
  } catch (e) {
    // Handle the case where the policy already exists
    console.warn('TrustedTypePolicy "default" already exists or cannot be created.', e);
  }
}

ReactDOM.render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
        <BrowserRouter>
          <AuthProvider>
            <Routes>
              <Route path="/auth/*" element={<AuthLayout />} />
              <Route path="/home/*" element={<HomeLayout />} />
              <Route path="*" element={<Navigate to="/home/favorites" replace />} />
            </Routes>
          </AuthProvider>
        </BrowserRouter>
    </ChakraProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
